<template>
  <div class="dataTables_wrapper no-footer mtable">
    <!-- 组件头部： -->
    <div class="datatable-header mtable-tool hui-group-dib-box">
      <!-- 子组件：搜索框 -->
      <seek v-if="seekDropdown" @seek="seek" :hideBtn="true" class="pull-left m-r-30 mtable-tool-seek" :seekDropdown="seekDropdownProps"></seek>
      <div class="seek pull-left m-r-30 mtable-tool-seek">
        <div  class="pull-left seekDropdown dropdown">
          <button class="btn btn-default dropdown-toggle hui-dropdown-toggle no-pointer" type="button">
            <span>{{multiLanguage.ibcAccount}}</span>
          </button>
        </div>
        <div class="pull-left form-group">
          <input type="text" class="form-control hui-form-control" v-model="ibcAccount" :placeholder="multiLanguage.search">
        </div>
        <div  class="pull-left seekDropdown dropdown" style="margin-left:15px;border-radius:3px">
          <button class="btn btn-default dropdown-toggle hui-dropdown-toggle no-pointer" type="button">
            <span>{{multiLanguage.th.specialCommission}}</span>
          </button>
        </div>
        <div class="pull-left form-group">
          <Dropdown ref="dropdown">
            <button class="btn btn-default select-btn" type="button"  data-role="trigger">
              <span>{{multiLanguage.ibSpecialType[ibSpecialType.listActive]}}</span>
              <span class="caret"></span>
            </button>
            <template slot="dropdown">
              <li><a role="button" @click="dropdownFnSpecial($event)">{{multiLanguage.ibSpecialType.all}}</a></li>
              <li><a role="button" @click="dropdownFnSpecial($event)">{{multiLanguage.ibSpecialType.special}}</a></li>
              <li><a role="button" @click="dropdownFnSpecial($event)">{{multiLanguage.ibSpecialType.normal}}</a></li>
            </template>
          </Dropdown>
        </div>
        <div class="pull-left btn btn-default btn-primary" style="margin-left:15px;border-radius:3px" @click="seek">{{multiLanguage.search}}</div>
        <div class="clear"></div>
      </div>
      <!-- 子组件：条目數，配合分页使用 -->
      <selPage v-if="selPage" class="pull-right" :multiLanguage="multiLanguage" :selPage="selPage" @selPage="selPageFn"></selPage>
      <!-- 按钮组：全部数据、下载excel、全部状态 -->
      <div class="btn-group p-0 pull-left mtable-tool-fn">
        <div class="btn btn-default" @click="refresh"><i class="glyphicon glyphicon-refresh tab-he-glyphicon"></i>{{multiLanguage.refreshData}}</div>
        <button class="btn btn-default" @click="excelCallbackFn">
              <i class="glyphicon glyphicon-save tab-he-glyphicon"></i>{{multiLanguage.downloadExcelForms}}
        </button>
        <Dropdown ref="dropdown">
          <button class="btn btn-default select-btn" type="button"  data-role="trigger">
            <span>{{multiLanguage.isSetting[isSetting.listActive]}}</span>
            <span class="caret"></span>
          </button>
          <template slot="dropdown">
            <li><a role="button" @click="dropdownFn($event)">{{multiLanguage.isSetting.checked}}</a></li>
            <li><a role="button" @click="dropdownFn($event)">{{multiLanguage.isSetting.unchecked}}</a></li>
            <li><a role="button" @click="dropdownFn($event)">{{multiLanguage.isSetting.unsated}}</a></li>
            <li><a role="button" @click="dropdownFn($event)">{{multiLanguage.isSetting.allStatus}}</a></li>
          </template>
        </Dropdown>
        <Dropdown ref="droptemplate" style="margin-left:10px;">
          <button class="btn btn-default select-btn" type="button"  data-role="trigger" style="max-width:150px;overflow:hidden;">
            <span>{{ibTemplate[templateSel.active]?ibCommissionLan[ibTemplate[templateSel.active].langKey] || templateSel.active:''}}</span>
            <span class="caret"></span>
          </button>
          <template slot="dropdown">
            <div style="height:350px;width:200px;overflow-y:scroll;">
            <li v-for="item in Object.keys(ibTemplate)" :key="item" class="template-li"><a role="button" @click="dropdownFnTemplate(ibTemplate[item])">
              {{ibCommissionLan[ibTemplate[item].langKey]||ibTemplate[item].templateId}}</a></li>
            </div>
          </template>
        </Dropdown>
        <Dropdown ref="dropdown" style="margin-left:-1px;">
          <button class="btn btn-default select-btn" type="button"  data-role="trigger">
            <span>{{multiLanguage['ibTempOverwriteType'][templateSel.overwritten]}}</span>
            <span class="caret"></span>
          </button>
          <template slot="dropdown">
            <li><a role="button" @click="templateSel.overwritten=2">{{multiLanguage['ibTempOverwriteType'][2]}}</a></li>
            <li><a role="button" @click="templateSel.overwritten=1">{{multiLanguage['ibTempOverwriteType'][1]}}</a></li>
            <li><a role="button" @click="templateSel.overwritten=0">{{multiLanguage['ibTempOverwriteType'][0]}}</a></li>
          </template>
        </Dropdown>
      </div>
      <div class="clear"></div>
    </div>
    <div class="datatable-header mtable-tool hui-group-dib-box">
      <div class="pull-left form-group"><span>{{multiLanguage.modifyTime}}</span>
        <el-date-picker style="width: 200px" type="datetime" placeholder="select" v-model="modifyTstart" ></el-date-picker>
        <span> -</span>
        <el-date-picker style="width: 200px" type="datetime" placeholder="select" v-model="modifyTend" ></el-date-picker>
      </div>
      <div class="pull-left form-group" style="margin-left:20px"><span>{{multiLanguage.confirmTime}}</span>
        <el-date-picker style="width: 200px" type="datetime" placeholder="select" v-model="confirmTstart" ></el-date-picker>
        <span> -</span>
        <el-date-picker style="width: 200px" type="datetime" placeholder="select" v-model="confirmTend" ></el-date-picker>
      </div>
      <div class="clear"></div>
    </div>
    <!-- 组件主体： -->
    <div class="datatable-scroll">
      <!-- 数据表 -->
      <table class="table table-bordered table-hover table-striped datatable-highlight dataTable no-footer" id="DataTables_Table_2" role="grid" aria-describedby="DataTables_Table_2_info">
        <thead>
          <tr role="row">
              <th v-for="(item,index) in thData" @click="sortFn(Object.keys(trData[0])[index])" :class="{sorting: sort && index == 1}">{{item}}</th>
              <th v-if="handle">{{multiLanguage.th.operation}}</th>
          </tr>
        </thead>
        <tbody>
          <tr role="row" v-show="trData.length > 0" v-for="(item,index) in trData">
            <td class="text-center">
              <i v-if="item.isSpecial" class="glyphicon glyphicon-ok" style="color:#2196F3;"></i>
              <i v-else class="glyphicon glyphicon-minus"></i>
            </td>
            <td>{{item.node_id}}</td>
            <td>{{item.ibc}}</td>
            <td>{{item.node_code}}</td>
            <td>{{item.name}}</td>
            <td>{{item.phone}}</td>
            <td>{{item.email}}</td>
            <td>{{item.updateBy}}</td>
            <td>{{item.confirmBy}}</td>
            <td>{{templateLang(item)}}</td>
            <td v-if="item.enable == 0 ">{{multiLanguage.ibStatus.disenable}}</td>
            <td v-else>{{multiLanguage.ibStatus.enable}}</td>
            <td v-if="item.ib_rebatesetting == 2">{{multiLanguage.isSetting.checked}}</td>
            <td v-else-if="item.ib_rebatesetting == 1">{{multiLanguage.isSetting.unchecked}}</td>
            <td v-else-if="item.ib_rebatesetting == 0">{{multiLanguage.isSetting.unsated}}</td>
            <td v-if="handle" class="text-center pointer" @click="linkRegister(item)">
              <i class="icon-compose"></i>
            </td>
          </tr>
        </tbody>
      </table>
      <!-- 子组件：没有查询到数据 -->
      <noData v-if="trData.length==0" :text="multiLanguage.nodata" :fontSize="'18'"></noData>
    </div>
    <!-- 组件尾部： -->
    <div class="datatable-footer" v-if="selPage">
      <!-- 条目详细：总数、当前第几条 -->
      <div class="dataTables_info" id="DataTables_Table_2_info" role="status" aria-live="polite">
        {{multiLanguage.clauses}}{{multiLanguage.amount}}:&nbsp;
        {{page.pageLeng}}&nbsp;&nbsp;{{multiLanguage.present}}:&nbsp;{{page.active*selPage.limit-selPage.limit+1}}-{{Math.min(page.active*selPage.limit,page.pageLeng)}}
      </div>
      <!-- 页码： -->
      <div v-if="Math.ceil(page.pageLeng/selPage.list[selPage.active])" class="dataTables_paginate paging_simple_numbers" id="DataTables_Table_2_paginate">
        <pagination v-model="page.active" 
          :boundary-links="true" :direction-links="true" 
          :total-page="Math.ceil(page.pageLeng/selPage.list[selPage.active])" 
          :max-size="page.pagenum" @change="callpageFn">
        </pagination>
      </div>
    </div>
  </div>
</template>

<script>
  import seek from "components/commissionSeek" // 导入子组件：搜索框
  import selPage from "components/selPage" // 导入子组件：条目数，配合分页使用
  import noData from "components/noData"  // 导入子组件： 查询不到数据
  import { Dropdown,Pagination } from "uiv" // 导入第三方组件，Dropdown下拉菜单,Pagination页码
  import { mapMutations } from "vuex"   // 导入状态管理，mapMutations

  export default {
    mixins: [ require("common/mixin/base.js").base({ibCommissionLan:"ibCommission"}), ],
    props: { // 接收父组件传递过来的数据，且验证数据格式

      isSetting: { // 是否设定的状态
        type: Object,
        default: {}
      },
      ibSpecialType: {
        type: Object,
        default: {}
      },
      thData: {  // 表头数据
        type: Array,
        default: []
      },
      trData: { // 表主体数据
        type: Array,
        default: []
      },  
      handle: { // 操作信息
        default: false
      },
      sort: { // 排序方式
        default: false
      },
      multiLanguage: {  // 多语言
        type: Object,
        default: {}
      },
      seekDropdown: {  // 搜索功能的选项
        default: false
      },
      selPage: {  // 显示条目数
        default: false
      },
      page: {  // 分页
        default: false
      },
      region: { // 地区信息
        defalut: false
      },
      ibc: { // ibc search box
        defalut: ''
      },
      modifyTime: {
        defalut: ''
      },
      confirmTime: {
        defalut: ''
      },
      templateSel: {
        type: Object,
        defalut: {}
      },
      ibTemplate: {
        type: Object,
        defalut: {}
      },
    },
    components: { // 子组件声明
      seek,
      selPage,
      noData,
      Dropdown,
      Pagination
    },
    data () {
      return {
        seekDropdownProps: this.seekDropdown ? this.seekDropdown : "",
        ibcAccount: '',
        modifyTstart:'',
        modifyTend:'',
        confirmTstart:'',
        confirmTend:'',
      }
    },
    methods: {
    excelCallbackFn() {
      this.$emit('downLoadExcelFn')
    },
    dropdownFn (e) {
      if (e.target.innerHTML == this.multiLanguage.isSetting.checked) {
        this.isSetting.active = 2
        this.isSetting.listActive = 'checked'
      }
      else if (e.target.innerHTML == this.multiLanguage.isSetting.unchecked) {
        this.isSetting.active = 1
        this.isSetting.listActive = 'unchecked'
      }
      else if (e.target.innerHTML == this.multiLanguage.isSetting.unsated) {
        this.isSetting.active = 0
        this.isSetting.listActive = 'unsated'
      } 
      else {
        this.isSetting.active = null
        this.isSetting.listActive = 'allStatus'
      }
      if (this.$parent.page) this.$parent.page.active = 1
      if (this.$parent.page) this.$parent.page.offset = 0
      this.$emit("tableChange")
    },
    dropdownFnSpecial (e) {
      if (e.target.innerHTML == this.multiLanguage.ibSpecialType.all) {
        this.ibSpecialType.active = 2
        this.ibSpecialType.listActive = 'all'
      }
      else if (e.target.innerHTML == this.multiLanguage.ibSpecialType.special) {
        this.ibSpecialType.active = 1
        this.ibSpecialType.listActive = 'special'
      }
      else if (e.target.innerHTML == this.multiLanguage.ibSpecialType.normal) {
        this.ibSpecialType.active = 0
        this.ibSpecialType.listActive = 'normal'
      }
      else {
        this.ibSpecialType.active = 2
        this.ibSpecialType.listActive = 'all'
      }
      if (this.$parent.page) this.$parent.page.active = 1
      if (this.$parent.page) this.$parent.page.offset = 0
      this.$emit("tableChange")
    },
    dropdownFnTemplate (item) {
      this.templateSel.active = item.templateId
      if (this.$parent.page) this.$parent.page.active = 1
      if (this.$parent.page) this.$parent.page.offset = 0
      this.$emit("tableChange")
    },
    linkRegister (item) {
      this.$router.push({
        path: this.handle.link,
        query: {
          id: item[this.handle.idKey],
          ibc: item.ibc,
          region: this.region
        }
      })
    },
    refresh () {
      if (this.$parent.page) this.$parent.page.active = 1
      if (this.$parent.page) this.$parent.page.offset = 0
      if (this.$parent.seekDropdown) this.$parent.seekDropdown.seekStr = ""
      this.ibcAccount = ''
      this.$nextTick(()=>this.$emit("tableChange"))
    },
    sortFn (key) {
      if (!this.sort || this.$parent.sort.key !== key) return
      if (this.sort.method === "ASC") {
        this.$parent.sort.method = "DESC"
      } else if (this.sort.method === "DESC") {
        this.$parent.sort.method = "ASC"
      }
      this.$emit("tableChange")
    },
    seek (seekStr) {
      this.$parent.page.active = 1
      if (this.page) this.$parent.page.offset = 0
      if (this.$parent.page) this.$parent.page.active = 1
      this.$emit("seek")
    },  
    clickSeekDropdown (index) {
      this.$emit("clickSeekDropdown", index)
    },
    callpageFn (index) {
      this.$parent.page.active = index
      this.$parent.page.offset = this.selPage ? (this.page.active - 1) * this.selPage.list[this.selPage.active] : ""
      this.$emit("tableChange")
    },
    selPageFn (index, item) {
      this.SAVEPAGEMAXINDEX(index)
      this.$parent.selPage.active = index
      this.$parent.selPage.limit = this.selPage.list[this.selPage.active]
      this.$parent.page.offset = 0
      this.$parent.page.active = 1
      this.$emit("tableChange")
    },
    templateLang(item){
      let tmplang = `${this.ibCommissionLan[item.templateId]||item.templateId}`
      if(tmplang){
        let i = item.templateOverwritten?1:0
        tmplang += `(${this.multiLanguage.ibTempOverwriteType[i]})`
      }
      return tmplang
    },
    ...mapMutations(["SAVEPAGEMAXINDEX"])
    },
    watch:{
      ibcAccount(val,old){
        this.$emit('update:ibc', val);
      },
      modifyTstart(val,old){
        let start = val?val:new Date(1000)
        let end = this.modifyTend?this.modifyTend:new Date()
        this.$emit('update:modifyTime', [start,end]);
      },
      modifyTend(val,old){
        let start = this.modifyTstart?this.modifyTstart:new Date(1000)
        let end = val?val:new Date()
        this.$emit('update:modifyTime', [start,end]);
      },
      confirmTstart(val,old){
        let start = val?val:new Date(1000)
        let end = this.confirmTend?this.confirmTend:new Date()
        this.$emit('update:confirmTime', [start,end]);
      },
      confirmTend(val,old){
        let start = this.confirmTstart?this.confirmTstart:new Date(1000)
        let end = val?val:new Date()
        this.$emit('update:confirmTime', [start,end]);
      },
      'templateSel.overwritten'(val,old){
        this.seek()
      },
    }
  }
</script>

<style lang="scss" scoped>
  .mtable{
    .datatable-scroll{
      .table{
        thead{
          border-top: 1px solid #ddd;
          tr {
            background-color: #EBEDF7;
          }
        }
      }
    }
    .mtable-tool{
      padding: 0 20px 25px;
      border-bottom: 0;
      .mtable-tool-seek,.mtable-tool-selPage,.mtable-tool-fn {
        padding-top: 20px;
        line-height: 36px;
      }
      .mtable-tool-fn {
        .radius-r{
          border-top-right-radius: 3px !important;
          border-bottom-right-radius: 3px !important;
        }
      }
    }
    .template-li{
      a{
        padding: 8px 15px;
        outline: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        display:block;
        clear: both;
        font-weight: normal;
        line-height: 1.5384616;
        color: #333333;
        white-space: nowrap;
      }
      :hover,:focus{
        color:#333333;
        text-decoration:none;
        background-color: #f5f5f5;;
      }
    }
  }
</style>




// WEBPACK FOOTER //
// iTable.vue?1cbc3dd1